"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCallToActionResponseToJSON = exports.AdCallToActionResponseFromJSONTyped = exports.AdCallToActionResponseFromJSON = exports.instanceOfAdCallToActionResponse = void 0;
var runtime_1 = require("../runtime");
var ClickthroughApplicationLink_1 = require("./ClickthroughApplicationLink");
/**
 * Check if a given object implements the AdCallToActionResponse interface.
 */
function instanceOfAdCallToActionResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "clickthroughUrl" in value;
    return isInstance;
}
exports.instanceOfAdCallToActionResponse = instanceOfAdCallToActionResponse;
function AdCallToActionResponseFromJSON(json) {
    return AdCallToActionResponseFromJSONTyped(json, false);
}
exports.AdCallToActionResponseFromJSON = AdCallToActionResponseFromJSON;
function AdCallToActionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': !(0, runtime_1.exists)(json, 'key') ? undefined : json['key'],
        'text': !(0, runtime_1.exists)(json, 'text') ? undefined : json['text'],
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
        'locale': !(0, runtime_1.exists)(json, 'locale') ? undefined : json['locale'],
        'clickthroughUrl': json['clickthrough_url'],
        'clickthroughUri': !(0, runtime_1.exists)(json, 'clickthrough_uri') ? undefined : json['clickthrough_uri'],
        'clickthroughApplicationLink': !(0, runtime_1.exists)(json, 'clickthrough_application_link') ? undefined : (0, ClickthroughApplicationLink_1.ClickthroughApplicationLinkFromJSON)(json['clickthrough_application_link']),
    };
}
exports.AdCallToActionResponseFromJSONTyped = AdCallToActionResponseFromJSONTyped;
function AdCallToActionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'text': value.text,
        'language': value.language,
        'locale': value.locale,
        'clickthrough_url': value.clickthroughUrl,
        'clickthrough_uri': value.clickthroughUri,
        'clickthrough_application_link': (0, ClickthroughApplicationLink_1.ClickthroughApplicationLinkToJSON)(value.clickthroughApplicationLink),
    };
}
exports.AdCallToActionResponseToJSON = AdCallToActionResponseToJSON;
